import React from "react";
import RippleLoader from "../../assets/images/loader-square.svg";
import { CircularProgress } from "@material-ui/core";

const Loading = ({ width, height, className }) => {
	return (
		<div className={className}>
			{/* <img src={RippleLoader} width={width} height={height} alt={"loader"} /> width={width} height={height} */}
			<CircularProgress
				style={{ color: "#072A40" }}
				size={width + "px"}
				//  size={width}
			/>
		</div>
	);
};
export default Loading;
